import { UnmanagedBusinessFactory } from '@/coreDomainsModule/factories/UnmanagedBusinessFactory';
import { UnmanagedBusinessState } from './types';
import { ImportFileType } from '@/coreDomainsModule/entities/unmanagedBusiness';
import { contentPropertyType } from '@/unmanagedBusinessModule/constants/contentProperty';
import { initPagingOptions } from '@/coreDomainsModule/paging';

export const modalStateDefault: UnmanagedBusinessState['modalInfo']['modalState'] = {
  registerBusiness: {
    supplierName: '',
    supplierNumber: '',
    businessNumber: '',
    businessName: '',
    package: '',
    warehouseName: '',
    warehouseNumber: '',
    customerName: '',
    customerNumber: '',
    salesDestinationName: '',
    salesDestinationNumber: '',
    unit: '',
    leadTime: '',
    leadTimeUnit: '',
    stdInventoryIndicesMin: '',
    stdInventoryIndicesMax: '',
    stdInventoryIndicesUnit: '',
    moq: '',
    endUser: '',
    manufacturer: '',
    businessFreeColumnValues: [],
  },
  checkDuplication: {
    aggregateBusinessId: '',
    businessId: '',
    isDiff: false,
    diffInfo: {
      unit: '',
      moq: 0,
      leadTime: 0,
      leadTimeUnit: '',
      stdInventoryIndicesMin: 0,
      stdInventoryIndicesMax: 0,
      stdInventoryIndicesUnit: '',
    },
    inputInfo: {
      unit: '',
      moq: 0,
      leadTime: 0,
      leadTimeUnit: '',
      standardInventoryIndexMin: 0,
      standardInventoryIndexMax: 0,
      standardInventoryIndexUnit: '',
    },
  },
  inventoryExecutionDate: {
    executionDate: new Date(),
  },
  registerAnnounceStartDate: {
    year: '',
    month: '',
  },
  noDuplication: {
    existsAggregateBusiness: false,
  },
  registerLeadTimeAndEtc: {
    warehouseNumber: '',
    warehouseName: '',
    supplierNumber: '',
    supplierName: '',
    customerNumber: '',
    customerName: '',
    salesDestinationNumber: '',
    salesDestinationName: '',
    businessNumber: '',
    businessName: '',
    package: '',
    unit: '',
    leadTime: '',
    leadTimeUnit: '',
    stdInventoryIndicesMin: '',
    stdInventoryIndicesMax: '',
    stdInventoryIndicesUnit: '',
    moq: '',
    manufacturer: '',
  },
};

export const unmanagedBusinessStateDefault: UnmanagedBusinessState = {
  settingUnmanagedBusiness: UnmanagedBusinessFactory.create({ importFileType: ImportFileType.Arrival }),
  businesses: [],
  tableInfo: {
    [ImportFileType.Announce]: {
      tableContentProperties: contentPropertyType[ImportFileType.Announce],
      tableContentItems: [],
      selectOptionInfo: {},
      isReset: false,
      loadingState: {
        status: { type: 'success' },
      },
      pagingState: initPagingOptions(30),
      sortState: {
        sortTarget: undefined,
        isAsc: true,
      },
    },
    [ImportFileType.SalesResult]: {
      tableContentProperties: contentPropertyType[ImportFileType.SalesResult],
      tableContentItems: [],
      selectOptionInfo: {},
      isReset: false,
      loadingState: {
        status: { type: 'success' },
      },
      pagingState: initPagingOptions(30),
      sortState: {
        sortTarget: undefined,
        isAsc: true,
      },
    },
    [ImportFileType.Inventory]: {
      tableContentProperties: contentPropertyType[ImportFileType.Inventory],
      tableContentItems: [],
      selectOptionInfo: {},
      isReset: false,
      loadingState: {
        status: { type: 'success' },
      },
      pagingState: initPagingOptions(30),
      sortState: {
        sortTarget: undefined,
        isAsc: true,
      },
    },
    [ImportFileType.Arrival]: {
      tableContentProperties: contentPropertyType[ImportFileType.Arrival],
      tableContentItems: [],
      selectOptionInfo: {},
      isReset: false,
      loadingState: {
        status: { type: 'success' },
      },
      pagingState: initPagingOptions(30),
      sortState: {
        sortTarget: undefined,
        isAsc: true,
      },
    },
    modal: {
      tableContentProperties: contentPropertyType.modal,
      tableContentItems: [],
      selectOptionInfo: {},
      isReset: false,
      loadingState: {
        status: { type: 'success' },
      },
      pagingState: initPagingOptions(30),
      sortState: {
        sortTarget: undefined,
        isAsc: true,
      },
    },
    modalWhenAggregateRow: {
      tableContentProperties: contentPropertyType.modalWhenAggregateRow,
      tableContentItems: [],
      selectOptionInfo: {},
      isReset: false,
      loadingState: {
        status: { type: 'success' },
      },
      pagingState: initPagingOptions(30),
      sortState: {
        sortTarget: undefined,
        isAsc: true,
      },
    },
  },
  checkedIds: {
    [ImportFileType.Announce]: [],
    [ImportFileType.SalesResult]: [],
    [ImportFileType.Inventory]: [],
    [ImportFileType.Arrival]: [],
  },
  selectedFileType: ImportFileType.Announce,
  modalInfo: {
    isOpen: {
      registerBusiness: false,
      noDuplication: false,
      detectDuplication: false,
      successRegister: false,
      successRegisterWithAggregate: false,
      successUpdateExistBusiness: false,
      questionUpdateExistBusiness: false,
      loading: false,
      error: false,
      delete: false,
      registerInventoryExecutionDateModal: false,
      registerAnnounceStartDateModal: false,
      questionUpdateExistBusinessLeadTimeAndStdInventoryIndices: false,
      questionUpdateExistBusinessDiff: false,
    },
    modalState: modalStateDefault,
  },
};
